export default "__VITE_ASSET__71b55424__"